var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"link":""},on:{"click":_vm.visitAssociatedPage}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.item.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }